<template>
  <div class="mx-auto container container--fluid">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table :headers="headers" :items="subcaste_master_list" class="elevation-1 mytable" dense :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Sub Caste</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="left" dense>
            <v-col sm="3" md="3" cols="12"> </v-col>
            <v-col sm="6" md="4" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>Add SubCaste</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                          <v-autocomplete
                            v-model="addedItem.subcaste_super_master_lists"
                            :items="subcaste_super_master_list"
                            item-text="name"
                            return-object
                            multiple
                            clearable
                            label="Select SubCaste">
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                          <v-text-field v-model="editedItem.cast" persistent-hint :disabled="editedIndex != -1"
                            :rules="[(v) => !!v || 'required']" :hint="
                              editedIndex == -1
                                ? 'For example :: Maratha, Brahmin '
                                : 'noneditable'
                            " label="Caste"></v-text-field>
                        </v-col>
                        
                        <!-- <v-col cols="12" sm="12" md="12">
                    <v-select dense
                      :items="cast_super_master_list"
                      v-model="editedItem.cast"
                      item-text="cast_super_master_list_id"
                      item-value="id"
                      persistent-hint
                      :disabled="editedIndex != -1"
                      :hint="editedIndex==-1?'For example :: Maratha, Brahmin':'noneditable'"
                      :filled="editedIndex==-1?false:true"
                      label="Cast"
                      :error="errorMsg.cast?true:false"
                      :error-messages="errorMsg.cast?'Required':''"
                    ></v-select>
                  </v-col> -->
                      </v-row>
                      <v-row>
                        <v-col cols="12" v-if="editedIndex == -1">
                          <v-text-field
                            label="Sub Caste In Unicode"
                            v-model="addedItem.unicode_subcaste"
                            persistent-hint
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field label="Sub caste In Unicode" v-model="editedItem.unicode_subcaste"  v-if="editedIndex != -1"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                          <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col v-if="editedIndex == -1">
                          <v-checkbox dense v-model="newcastcheckbox" color="success"
                            label="Caste not present in above list? Add new here..."></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1 && newcastcheckbox">
                          <v-text-field v-model="newcast" persistent-hint hint="For example :: Maratha, Brahmin"
                            label="New Caste" ref="newcast"></v-text-field>
                        </v-col>
                        <v-col v-if="editedIndex == -1 && newcastcheckbox">
                          <v-text-field label="New Sub caste In Unicode" v-model="unicode_new_subcaste"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" v-if="newcastcheckbox">
                          <v-btn class="mb-2 button" color="primary" small @click="saveNewCast">Save New Sub
                            Caste</v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
          <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    subcaste_super_master_list: [],
    // extraBreadcrumbItems: [
    //   { text: "Sub Cast  Master", disabled: true, href: "" },

    // ],


    // breadcrumbClass: "breadcrumb-style2",
    overlay: false,
    cast: ["Matartha", "Brahmin", "test", "aa", "asd"],
    errorMsg: {
      cast: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    newcast: "",
    unicode_new_subcaste:"",
    newcastcheckbox: false,
    headers: [
      {
        text: "Sub Caste",
        align: "left",
        sortable: false,
        value: "cast",
      },
      {
        text: "Sub Caste In Unicode",
        align: "left",
        sortable: false,
        value: "unicode_subcaste",
      },
      {
        text: "Active",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    subcaste_master_list: [],
    editedIndex: -1,
    addedItem: {
      // cast_super_master_list: "",
      subcaste_super_master_lists: []
    },
    editedItem: {
      id: "",
      cast: "",
      unicode_subcaste:"",
      isactive: true,
    },
    defaultItem: {
      id: "",
      cast: "",
      unicode_subcaste:"",
      isactive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Caste" : "Edit Caste";
    },
  },

  watch: {
     'addedItem.subcaste_super_master_lists'(val) {
        if (val && val.length) {
          this.addedItem.unicode_subcaste = val.map(item => item.unicode_name).filter(name => name && name.trim() !== '').join(', ')
        } else {
          this.addedItem.unicode_subcaste = ''
        }
    },
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    //   initialize () {

    //   },
    saveNewCast() {
      if (this.newcast.length == 0) {
        this.showSnackbar("#b71c1c", "Please add Sub Caste!");
        this.$refs["newcast"].focus();
        return;
      }
      let data = {
        newcast: this.newcast,
        unicode_new_subcaste : this.unicode_new_subcaste
      };
      this.overlay = true;
      axios
        .post("/AdmissionMaster/addNewSubCast", data)
        .then((res) => {
          (this.newcast = ""),
            (this.newcastcheckbox = false),
            (this.overlay = false);
          if (res.data.status.code == "SUCCESS") {
            this.showSnackbar("#4caf50", "Sub Caste Added Successfully!!!"); // show snackbar on success
            this.onLoad();
          } else if (res.data.status.code == "NA") {
            this.showSnackbar("#b71c1c", "Sub Caste Already Present!"); // show snackbar on error
          }
        })
        .catch((error) => {
          this.overlay = false;
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
      this.close();
    },
    editItem(item) {
      this.editedIndex = this.subcaste_master_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/AdmissionMaster/Subcaste")
        .then((res) => {
          if (res.data.msg == "200") {
            //window.alert(res.data.msg)

            if ((this.load = true)) {
              this.overlay = false;
              this.subcaste_master_list = res.data.subcaste_master_list;
              this.subcaste_super_master_list = res.data.subcaste_super_master_list;
            }
          } else {
            window.console.log(res.data.msg);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    // deleteItem (item) {
    //   const index = this.cast_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.cast_master_list.splice(index, 1)
    // },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
      this.addedItem = {
        subcaste_super_master_lists: [],
        unicode_subcaste: ""
      };
      (this.newcast = ""), (this.newcastcheckbox = false);
      this.unicode_new_subcaste = ""
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/AdmissionMaster/editSubCast", this.editedItem)
            .then((res) => {
              if (res.data.msg == "200") {
                //window.alert(res.data.msg)
                // Object.assign(this.cast_master_list[this.editedIndex], this.editedItem)
                this.onLoad();
              }
              this.showSnackbar("#4caf50", "Sub Caste Updated Successfully..."); // show snackbar on success
            })
            .catch((error) => {
              window.console.log(error);
            });
          this.close();
        }
      } else {
        //this.cast_master_list.push(this.editedItem)
        axios
          .post("/AdmissionMaster/saveSubCaste", this.addedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              //window.alert(res.data.status.code)
              this.subcaste_master_list.push(this.addedItem);
              this.showSnackbar("#4caf50", "Sub Caste Added Successfully!!!"); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              //window.alert(res.data.status.code)
              // alert(res.data.status.message)
              this.showSnackbar("#b71c1c", "Sub Caste Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    }, //save()
    isValidated() {
      if (this.editedItem.cast) {
        return true;
      } else {
        if (!this.editedItem.cast) {
          this.errorMsg.cast = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>